import React from 'react'
import styled from 'styled-components'

const DivStyled = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 22px;
  border-width: 2px;
  border-color: var(--yellow);
  border-style: solid;

  div {
    width: 25px;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  svg {
    width: 100%;
    height: 100%;
  }
`

const PhoneIcon = () => (
  <DivStyled>
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="52.281"
        height="56.812"
        viewBox="0 0 52.281 56.812"
        data-prefix="ibpujlgfr"
      >
        <path
          d="M30.485 11.318a14.09 14.09 0 0 1 8.987 6.125 14.25 14.25 0 0 1 2.066 10.725 1.5 1.5 0 0 0 1.158 1.764 1.453 1.453 0 0 0 .3.031 1.489 1.489 0 0 0 1.454-1.2 17.244 17.244 0 0 0-2.5-12.971 17.043 17.043 0 0 0-10.872-7.407 1.496 1.496 0 0 0-.593 2.933zm-2.334 7.108a7.729 7.729 0 0 1 5.978 9.111 1.493 1.493 0 0 0 1.157 1.764 1.46 1.46 0 0 0 .3.031 1.489 1.489 0 0 0 1.454-1.2 10.723 10.723 0 0 0-8.293-12.64 1.497 1.497 0 0 0-.596 2.934zm11.074 16.207a3.84 3.84 0 0 0-2.945-.956 4.5 4.5 0 0 0-2.935 1.843c-.448.566-1.209 1.516-1.474 1.829-1.788 2.112-3.033 1.407-3.869.874a47.475 47.475 0 0 1-6.429-7.1 1.086 1.086 0 0 0-.076-.1l-.029-.04a2.49 2.49 0 0 0-.064-.08 47.636 47.636 0 0 1-5.281-8.042c-.311-.942-.691-2.323 1.785-3.554.041-.019.106-.046.191-.082a11.5 11.5 0 0 0 3.532-2.144 3.969 3.969 0 0 0 .841-4.678 89.454 89.454 0 0 0-6.249-10.355A4.345 4.345 0 0 0 10.089.754l1.639 2.493a1.392 1.392 0 0 1 2.089.555 87.065 87.065 0 0 1 5.983 9.904.953.953 0 0 1-.268 1.255 9.126 9.126 0 0 1-2.588 1.5 8.93 8.93 0 0 0-.345.153c-2.225 1.107-4.6 3.266-3.266 7.268.017.052.038.1.06.153a49.992 49.992 0 0 0 5.7 8.737l.037.047c.018.026.037.051.056.075a49.712 49.712 0 0 0 7.011 7.7 1.354 1.354 0 0 0 .138.1c3.538 2.266 6.194.483 7.8-1.409.329-.388 1.194-1.472 1.537-1.905l.04-.051a1.648 1.648 0 0 1 .928-.689 1.018 1.018 0 0 1 .714.306 81.707 81.707 0 0 1 7.833 7.181 1.692 1.692 0 0 0 .125.142c1.422 1.423.979 2.274.833 2.553a1.5 1.5 0 0 0 .627 2.018 1.457 1.457 0 0 0 .688.171 1.484 1.484 0 0 0 1.317-.8c.479-.92 1.3-3.334-1.305-6-1.578-1.965-6.891-6.465-8.247-7.578zm-19.755-1.5a1.486 1.486 0 0 0 .344.163 1.486 1.486 0 0 1-.344-.168zM33.4 1.343a1.494 1.494 0 0 0-.595 2.929 20.8 20.8 0 0 1 16.088 24.523 1.494 1.494 0 0 0 1.157 1.764 1.467 1.467 0 0 0 .3.031 1.489 1.489 0 0 0 1.454-1.2A23.794 23.794 0 0 0 33.4 1.338zm11.683 49.332a1.5 1.5 0 0 0-.05-.152c-.015-.042-.026-.084-.044-.125s-.045-.081-.068-.121a1.341 1.341 0 0 0-.082-.137c0-.006-.006-.012-.01-.018-.028-.038-.062-.067-.093-.1s-.051-.065-.081-.094l-6.569-6.21a1.479 1.479 0 0 0-2.1.066 1.5 1.5 0 0 0 .066 2.113l5.246 4.96c-2.824 1.919-5.267 2.964-6.981 2.964a4.858 4.858 0 0 1-2.251-.538 1.308 1.308 0 0 0-.124-.074 61.437 61.437 0 0 1-17.727-15.47l-.491-.637A61.838 61.838 0 0 1 3.17 15.985c0-.017-.012-.043-.018-.061a3.948 3.948 0 0 1-.025-2.239 18.856 18.856 0 0 1 3.5-5.662l3.958 6.447a1.483 1.483 0 0 0 1.265.709 1.468 1.468 0 0 0 .78-.224 1.5 1.5 0 0 0 .482-2.057l-4.9-7.983a1.491 1.491 0 0 0-.288-.332c-.019-.021-.033-.045-.054-.066a1.478 1.478 0 0 0-2.1.022 23.334 23.334 0 0 0-5.437 8.127 6.916 6.916 0 0 0-.031 4.1 65.133 65.133 0 0 0 11.077 22.169l.491.635c5 6.468 12.309 12.842 18.634 16.252a7.619 7.619 0 0 0 3.811.985c2.714 0 6.149-1.546 10.209-4.6a1.318 1.318 0 0 0 .129-.118c.021-.02.045-.035.065-.057l.009-.011a1.422 1.422 0 0 0 .126-.166c.017-.025.038-.048.053-.073a1.444 1.444 0 0 0 .083-.173c.014-.031.031-.06.043-.092a1.689 1.689 0 0 0 .045-.173c.008-.035.02-.07.025-.105a1.379 1.379 0 0 0 .012-.182c0-.034.006-.069 0-.1a1.333 1.333 0 0 0-.023-.178.398.398 0 0 0-.008-.109z"
          fillRule="evenodd"
          fill="white"
        ></path>
      </svg>
    </div>
  </DivStyled>
)

export default PhoneIcon
